export const VALIDATION_REQUIRED = 'Toto pole je povinné'
export const VALIDATIONPATTERN_PHONE = /(^((00|\+)420\s?)?[6-7]\s?(\d\s?){8}$)|^((00|\+)(?!420)\s?(\d\s?){9,15})$/
export const VALIDATIONPATTERN_EMAIL =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
